import { useAppContext } from 'QuoteApp/services/providers';

export const useReportCompliance = () => {
  const { details } = useAppContext();
  const addressState = details.address[details.principalInsuredId].state.value;

  return {
    canShowReportData: addressState !== 'CA',
  };
};
